import { useEffect, useState } from 'react';

const useViewMore = (height: number, idEl: string, visibleDefault: boolean = false) => {
  const [visible, setVisible] = useState(visibleDefault);
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    if (document) {
      const element = document.getElementById(idEl);
      const heightCurrent = element?.offsetHeight || 0;

      if (heightCurrent < height) {
        setIsShow(false);
        return;
      }

      setIsShow(true);
      if (visible && element) {
        element.style.height = 'auto';
      } else if (!visible && element) {
        element.style.height = `${height}px`;
        element.style.overflow = 'hidden';
      }
    }
  }, [visible]);

  const toggle = () => {
    setVisible(!visible);
  };

  return { toggle, isViewMore: visible, isShowBtn: isShow };
};

export default useViewMore;
